import { DataBean } from "../DataBean";

export class StateConstantsForTreasure extends DataBean {



    public async getStateConstantsForTreasure(id: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getStateConstantsForTreasure_Number", [id]);
    }

}